export default "__VITE_ASSET__DwvsiiHQ__"